import { useAppSelector } from "./store";
import "./EndGameReasons.css";

function EndGameReasons() {
  const reasons = useAppSelector((state) => {
    return state.endGameLeaderboard.endReasons;
  });

  return (
    <div>
      <ul>
        {reasons.map((reason) => (
          <li className="reasonItem" key={reason}>
            {reason}
          </li>
        ))}
      </ul>
    </div>
  );
}

export default EndGameReasons;
